import { render, staticRenderFns } from "./ProductDetailsInfo.vue?vue&type=template&id=64881b63"
import script from "./ProductDetailsInfo.vue?vue&type=script&lang=js"
export * from "./ProductDetailsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports